/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_HorizonInputs */

const cs_investor_horizon = /** @type {(inputs: Investor_HorizonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizont`)
};

const en_investor_horizon = /** @type {(inputs: Investor_HorizonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizon`)
};

/**
* | output |
* | --- |
* | "Horizon" |
*
* @param {Investor_HorizonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_horizon = /** @type {((inputs?: Investor_HorizonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_HorizonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_horizon(inputs)
	return cs_investor_horizon(inputs)
});